import gsap from 'gsap';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Contacts.scss';

function Contacts() {

  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = (e: React.MouseEvent) => {
    e.preventDefault();
    navigator.clipboard.writeText('conceptcube.info@gmail.com').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const tl :any = useRef()
  const timeLine = tl.current = gsap.timeline()
  
  useEffect(() => {
    timeLine.from('.slide-right', {
      x: '-50px',
      opacity: 0,
      duration: .7,
      stagger: {
        each: 0.3,
      },
    });
    timeLine.from('.slide-bottom', {
      y: '50px',
      opacity: 0,
      duration: .7,
      stagger: {
        each: 0.3,
      },
    },'+1');
  },[]);

  const activeLang = localStorage.getItem('i18nextLng');
  return (
    <div  className="contact">
      <div className="contact-container">
        <h2 className="contact-title slide-right">Contact us</h2>
        <div className="contact-main">
          <div className="contact-detail slide-right">
            <div className="top">
              {/* <div className="top-items">
                <p className="title slide-bottom">Work With Us.</p>
                <a href="#" className="link slide-bottom">
                  conceptcube.info@gmail.com
                </a>
              </div> */}
              <div className="top-items">
                <p className="title slide-bottom">Careers.</p>
                <a href="#" onClick={handleCopyEmail} className="link slide-bottom" style={{ cursor: 'pointer', position: 'relative' }}>
                  conceptcube.info@gmail.com
                  {copied && <span style={{ display: 'block', fontSize: '1.2rem', marginTop: '4px', opacity: 0.9 }}>{activeLang === 'kr' ? '복사되었습니다!' : 'Copied!'}</span>}
                </a>
              </div>
            </div>
            <div className="bottom slide-bottom">
              <p>
                {t('topContact')} <br /> {t('botContact')} <br />T 070-4272-8645
              </p>
            </div>
          </div>
          <div className="contact-map ">
            {activeLang === 'kr' ?
              <iframe
                title="looclocation"
                src="https://maps.google.com/maps?q=%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C%20%EA%B0%95%EB%8F%99%EA%B5%AC%20%EA%B3%A0%EB%8D%95%EB%A1%9C%2047&t=&z=16&ie=UTF8&iwloc=&output=embed"
                frameBorder="0"
                allowFullScreen
                className="slide-right"
              ></iframe>
              :

              <iframe
                title="looclocation"
                src="https://maps.google.com/maps?q=47%20Godeok-ro%2C%20Gangdong-gu%2C%20Seoul&t=&z=16&ie=UTF8&iwloc=&output=embed"
                frameBorder="0"
                allowFullScreen
                className="slide-right"
              ></iframe>
            }
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contacts;
